import { ReceiptsTable } from './ReceiptsTable';

export default ReceiptsTable;
